/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CustomOption from './CustomOption/index'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaListDialogItems from 'DesignSystem/TysiaListDialog/TysiaListDialogItems/react'
import TysiaListDialogSaveAction from 'DesignSystem/TysiaListDialog/TysiaListDialogSaveAction/index'
import TysiaListDialogTitle from 'DesignSystem/TysiaListDialog/TysiaListDialogTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/FilterAction/Content",
  closePopover,
  onValidateSubmit
  
}) {
let userPreferencesTimelineFilterPresetsValueData = fromData.useDataValue({ viewPath,
context: 'user_preferences',
path: 'timeline_filter_presets',
})
let selectedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath,
  closePopover,
  onValidateSubmit
  
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  closePopover,
  onValidateSubmit
  
})
let onFilter = fromHelpers.useOnFilter({
  children,
  viewPath,
  closePopover,
  onValidateSubmit
  
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 width={286}
 height="auto"
 data="user_preferences.timeline_filter_presets"
 items={userPreferencesTimelineFilterPresetsValueData}
 data="selected"
 selected={selectedValueData}
 onSubmit={onSubmit}
 onChange={onChange}
 closePopover={closePopover}
 onFilter={onFilter}
 onValidateSubmit={onValidateSubmit}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-3-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaListDialogTitle
  viewPath={`${viewPath}/TysiaListDialogTitle`}
 title="Show in timeline"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaListDialogSaveAction
  viewPath={`${viewPath}/TysiaListDialogSaveAction`}
 text="Save"
/>
</div>
</div>
<TysiaListDialogItems
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogItems`}
 itemDataContextName="item"
>
{childProps => (
<CustomOption
{...childProps}
/>
)}
</TysiaListDialogItems>
</React.Fragment>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}